import React, { useEffect } from 'react';
import styled from 'styled-components';
import MainSettlements from '../../components/templates/faculty/MainSettlements';
import { titleHTML } from '../../helpers/title.helper';
import useLayout from '../../hooks/useLayout';
import { ErpPaProvider } from './contexts/ErpPaProvider';

const FacultyPage = () => {
    titleHTML('Faculty');

    const { setMenu } = useLayout();

    useEffect(() => {
        setMenu('Honorarios y liquidaciones');
    }, []);

    return (
        <>
            {' '}
            <ErpPaProvider>
                <ContentWrapper>
                    <MainSettlements />
                </ContentWrapper>
            </ErpPaProvider>
        </>
    );
};

export default FacultyPage;

const ContentWrapper = styled.div`
    width: 100%;
`;
